<template>
  <div class="main-modal main-modal_w700" v-if="specialists" @click.stop>
    <div class="main-modal__title">{{ $t("request.responsibleTitle") }}</div>
    <div class="responsible__head">
      <!-- <tab-responsible
        :active="isActive"
        @changeView="changeView"
      ></tab-responsible>-->

      <Select2
        :options="services"
        :settings="selectSetting"
        class="select"
        :class="{ border: userlistHide }"
        v-model="selectedData"
        @select="selectUser($event)"
      />

      <search @searchData="searchUser" :value="search" class="responsible__head-search"></search>
    </div>
    <div class="responsible__body">
      <div class="userlist__wrapper" v-bar>
        <div class="userlist__block">
          <div class="userlist__items">
            <div class="userlist__disabled" v-if="userlistHide"></div>
            <transition-group name="list" tag="div">
              <div
                class="userlist__item"
                v-for="user in filteredItems"
                :key="user.id"
                @click="
                  addResponsible({
                    id: user.id,
                    small_image: user.small_image,
                    last_name: user.last_name,
                    first_name: user.first_name,
                    post: user.service.name,
                    service_id: user.service.id,
                  })
                "
              >
                <div class="userlist__block-text">{{ user.char }}</div>
                <div
                  class="userlist__item-img userlist__item-img--noborder"
                  v-if="
                    responsibleData.findIndex((item) => item.id === user.id) !==
                      -1
                  "
                >
                  <img src="/images/icon/selected.svg" alt />
                </div>
                <div
                  class="userlist__item-img"
                  :style="{ backgroundImage: getImageURL(user.small_image) }"
                  v-else
                ></div>
                <div
                  class="userlist__item-name"
                  :title="user.first_name + ' ' + user.last_name"
                >{{ user.first_name }} {{ user.last_name }}</div>
                <div class="userlist__item-post" :title="user.service.name">{{ user.service.name }}</div>

                <div
                  class="userlist__item-status"
                  :class="{ 'userlist__item-status--busy': user.is_busy }"
                ></div>
              </div>
            </transition-group>
            <div class="userlist__item" v-if="filteredItems.length === 0">{{ $t("lists.listEmpty") }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="responsible__buttons">
      <button class="main-button main-button_cancel" @click="closeModal">{{ $t("global.cancel") }}</button>
      <button
        class="main-button main-button_success"
        @click="confirmResponsible"
      >{{ $t("global.add") }}</button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'add-responsible-for-pdf',
    props: ['close', 'confirm', 'responsibleData', 'serviceId', 'hide', 'tags'],
    data() {
        return {
            isActive: 'masters',
            selectSetting: {
                placeholder: this.$t('request.servicesHold'),
            },
            search: '',
            selectedData: '',
            userlistHide: this.hide,
            defaultImage: '/images/default-user.svg',
        }
    },
    mounted() {
        const firstService = this.services[0]
        if (firstService) {
            this.selectedData = firstService.id ?? ' '
        }
        this.fetch({ type: this.isActive, tags: this.tags })
    },
    methods: {
        ...mapActions({
            fetch: 'specialists/getSpecialistsData',
        }),
        getImageURL(image) {
            return `url(${image === null ? this.defaultImage : image}`
        },
        changeView(view) {
            this.isActive = view
            this.fetch({ type: this.isActive })
        },
        selectUser({ id }) {
            this.responsibleData.splice(0, this.responsibleData.length)
            this.userlistHide = false
            this.selectedData = id
        },
        searchUser(data) {
            this.search = data
        },
        addResponsible(data) {
            const index = this.responsibleData.findIndex((item) => item.id === data.id)
            if (index === -1) {
                this.responsibleData.push(data)
            } else {
                this.responsibleData.splice(index, 1)
            }
        },
        closeModal() {
            this.$emit('close', 'cancel')
        },
        confirmResponsible() {
            this.$emit('confirm', this.responsibleData)
            this.$emit('close')
        },
    },
    computed: {
        ...mapGetters({
            masters: 'getMasters',
            engineers: 'getEngineers',
            specialists: 'specialists/getSpecialists',
            services: 'servicesGettersWithAll',
        }),
        filteredItems() {
            return this.$store.state.specialists.data.filter((item) => {
                if (this.selectedData === 'all') {
                    if (
                        item.last_name.toLowerCase().indexOf(this.search.toLowerCase())
              > -1
            && this.search
                    ) {
                        return item
                    } else if (
                        item.first_name.toLowerCase().indexOf(this.search.toLowerCase())
              > -1
            && this.search
                    ) {
                        return item
                    }

                    if (!this.search) return item
                } else {
                    if (
                        item.last_name.toLowerCase().indexOf(this.search.toLowerCase())
              > -1
            && this.search
            && this.selectedData
            && item.service.id.indexOf(this.selectedData) > -1
                    ) {
                        return item
                    } else if (
                        item.first_name.toLowerCase().indexOf(this.search.toLowerCase())
              > -1
            && this.search
            && this.selectedData
            && item.service.id.indexOf(this.selectedData) > -1
                    ) {
                        return item
                    }

                    if (!this.search && item.service.id.indexOf(this.selectedData) > -1) return item
                }
            })
        },
    },
}
</script>
<style lang="scss" scoped>
@import "src/assets/sass/main";
.responsible {
  padding: 64px;
  @include respond(smallhight) {
    padding: 40px;
  }
  &__title {
    font-size: 36px;
    color: $primaryColor;
    font-family: $fontMedium;
    text-align: center;
    margin-bottom: 64px;
    @include respond(smallhight) {
      margin-bottom: 40px;
    }
  }
  &__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 36px;
    &-search {
      max-width: 200px;
      border: solid 1px #e0e0e0;
    }
    &-select {
      max-width: 200px;
    }
  }
  &__body {
    width: 100%;
    height: 300px;
    margin-bottom: 48px;
    box-shadow: 0 2px 22px -10px #3e3e3e inset;
    border-radius: 8px;
    @include respond(smallhight) {
      margin-bottom: 30px;
    }
  }
  &__buttons {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 376px;
    margin-left: auto;
    margin-right: auto;
    & .button {
      width: 156px;
      color: $secondColor;
    }
  }
}

.border {
  border: 1px solid $primaryColor !important;
}

.list-enter-active {
  transition: all 0.5s;
}
.list-leave-active {
  transition: all 0.5s;
  position: absolute;
  // transform: translateY(-30px);
}
.list-enter,
.list-leave-to {
  opacity: 0;
  transform: translateY(30px);
}
</style>
